import styled from '@emotion/styled';
import { Button, Paper } from '@material-ui/core';
import React from 'react';
import pdf from '../../../assets/dummy.pdf';
import Box from '../../UI';
import NDAContent from './NDAContent';

export default function Modal({ setIsOpen, handleAcceptTerms, id }) {
	const wrapperRef = React.useRef(null);

	function handleClickOutside(event) {
		if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
			setIsOpen(false);
		}
	}

	React.useEffect(() => {
		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside);
		};
	});

	const escFunction = React.useCallback(
		event => {
			if (event.keyCode === 27) {
				setIsOpen(false);
			}
		},
		[setIsOpen]
	);

	React.useEffect(() => {
		document.addEventListener('keydown', escFunction, false);

		return () => {
			document.removeEventListener('keydown', escFunction, false);
		};
	}, [escFunction]);
	return (
		<Overlay>
			<Box width={['300px', '400px', '600px']} height="80%" p="15px" ref={wrapperRef} style={{ zIndex: 1000 }}>
				<Paper style={{ overflowY: 'scroll', height: '100%', padding: '30px' }}>
					<NDAContent id={id} />
					<Box display="flex" justifyContent="space-around" mt={5}>
						<a href={pdf} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
							<Button variant="contained" color="primary">
								Print PDF
							</Button>
						</a>
						<Button variant="contained" color="primary" onClick={() => setIsOpen(false)}>
							Reject terms
						</Button>
						<Button variant="contained" color="primary" onClick={handleAcceptTerms}>
							Accept terms
						</Button>
					</Box>
				</Paper>
			</Box>
		</Overlay>
	);
}

const Overlay = styled.div`
	width: 100vw;
	height: 100vh;
	zindex: 10;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 500;
`;
